export const RESET_TAGS = 'Tags/RESET_TAGS';
export const GET_TAGS = 'Tags/GET_TAGS';
export const GET_TAGS_SET_DATA = 'Tags/GET_TAGS_SET_DATA';
export const ADD_TAGS = 'Tags/ADD_TAGS';
export const ADD_TAGS_SET_DATA = 'Tags/ADD_TAGS_SET_DATA';
export const REMOVE_TAG = 'Tag/REMOVE_TAG';
export const REMOVE_TAG_SET_DATA = 'Tag/REMOVE_TAG_SET_DATA';
